module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-306fcb3ae8bf41e42e58f15246bf3089.webp";